import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { LocalStorageKeys } from '@app/utils/enums/local-storage';
import { LogInResponse } from '@app/utils/interfaces/log-in.interface';
import {
  VerifyTotpRequest,
  TokenResponse,
  Enable2FAResponse,
} from '@app/utils/interfaces/mfa.interface';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MFAService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public verifyTotp(data: VerifyTotpRequest): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(`${this.baseUrl}${ApiEndpoints.VERIFY_TOTP}`, data);
  }

  public enable2FA(confirmPassword: string): Observable<Enable2FAResponse> {
    return this.http.post<Enable2FAResponse>(`${this.baseUrl}${ApiEndpoints.ENABLE_2FA}`, {
      confirmPassword,
    });
  }

  public confirm2FA(totpCode: VerifyTotpRequest): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}${ApiEndpoints.CONFIRM_2FA}`, { totpCode });
  }

  public disable2FA(confirmPassword: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}${ApiEndpoints.DISABLE_2FA}`, { confirmPassword });
  }

  public get2FAStatus(): Observable<boolean> {
    const storedFAStatus = localStorage.getItem(LocalStorageKeys.TWO_FACTOR_STATUS_KEY);

    if (storedFAStatus) {
      return of(JSON.parse(storedFAStatus));
    }

    return of(false);
  }

  public determine2FAStatus(loginData: LogInResponse): boolean {
    const { accessToken, refreshToken, tempToken } = loginData.data;

    const isFAEnabled = !!(tempToken && (!accessToken || !refreshToken));

    return isFAEnabled;
  }

  public update2FAStatus(status: boolean): void {
    localStorage.setItem(LocalStorageKeys.TWO_FACTOR_STATUS_KEY, JSON.stringify(status));
  }

  public clear2FAStatus(): void {
    localStorage.removeItem(LocalStorageKeys.TWO_FACTOR_STATUS_KEY);
  }
}
